// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Переменные для цветов */
:root {
  --dark-purple: #3A0CA3;
  --medium-purple: #4361EE;
  --bright-purple: #B5179E;
  --darkest-purple: #21094E;
  --text-light: #E0E0E0;
  --text-accent: #BBBBBB;
  --border-color: #555;
  --error-color: #FF6B6B;
  --success-color: #6BFF8C;
}

body {
  margin: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background-color: var(--darkest-purple);
  color: var(--text-light);
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  overflow-x: hidden; /* Предотвращаем горизонтальный скролл */
}

.profilePage {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: 100vh;
  padding: 20px;
  box-sizing: border-box;
}

.header {
  width: 100%;
  max-width: 800px;
  text-align: left;
  margin-bottom: 20px;
}

.goHomeButton {
  background: linear-gradient(45deg, var(--medium-purple), var(--dark-purple));
  color: var(--text-light);
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: bold;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.4);
  text-transform: uppercase;
  letter-spacing: 1px;
}

.goHomeButton:hover {
  background: linear-gradient(45deg, var(--dark-purple), var(--medium-purple));
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.6);
  transform: translateY(-2px);
}

.goHomeButton:active {
  transform: translateY(0);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.profileContainer {
  background-color: rgba(30, 10, 60, 0.7); /* Полупрозрачный темный фон */
  border: 1px solid var(--dark-purple);
  border-radius: 15px;
  padding: 40px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.6);
  text-align: center;
  width: 100%;
  max-width: 600px;
  margin-bottom: 40px;
  backdrop-filter: blur(5px); /* Футуристичный эффект размытия */
  -webkit-backdrop-filter: blur(5px);
}

.title {
  color: var(--bright-purple);
  margin-bottom: 30px;
  font-size: 2.5rem;
  text-shadow: 0 0 10px rgba(181, 23, 158, 0.5);
}

.avatarSection {
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 50%;
}

.avatar {
  width: 80px !important;
  height: 80px !important;
  border-radius: 50%;
  object-fit: cover !important;
  border: 4px solid var(--medium-purple);
  box-shadow: 0 0 20px rgba(67, 97, 238, 0.7);
  transition: transform 0.3s ease;
  margin-bottom: 20px;
}

.avatar:hover {
  transform: scale(1.05);
}

.avatarUpload {
  display: flex;
  gap: 15px;
  align-items: center;
  flex-wrap: wrap; /* Для мобильных устройств */
  justify-content: center;
}

.fileInput {
  display: none; /* Скрываем стандартный инпут файла */
}

.fileInputLabel,
.uploadButton,
.editButton,
.saveButton,
.cancelButton {
  background: linear-gradient(45deg, var(--bright-purple), var(--dark-purple));
  color: var(--text-light);
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.95rem;
  font-weight: bold;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.4);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.fileInputLabel:hover,
.uploadButton:hover,
.editButton:hover,
.saveButton:hover {
  background: linear-gradient(45deg, var(--dark-purple), var(--bright-purple));
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.6);
  transform: translateY(-2px);
}

.fileInputLabel:active,
.uploadButton:active,
.editButton:active,
.saveButton:active {
  transform: translateY(0);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.uploadButton:disabled,
.saveButton:disabled {
  background: #555;
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
  opacity: 0.7;
}

.userInfo {
  margin-bottom: 30px;
}

.usernameDisplay {
  font-size: 1.6rem;
  color: var(--text-light);
  margin: 0;
}

.usernameDisplay span {
  color: var(--bright-purple);
  font-weight: bold;
  text-shadow: 0 0 8px rgba(181, 23, 158, 0.4);
}

.editButton {
  margin-top: 20px;
  min-width: 200px;
}

.editForm {
  margin-top: 30px;
  text-align: left;
  width: 100%;
}

.editForm h2 {
  color: var(--medium-purple);
  font-size: 1.8rem;
  margin-bottom: 25px;
  text-align: center;
  text-shadow: 0 0 8px rgba(67, 97, 238, 0.4);
}

.formGroup {
  margin-bottom: 20px;
}

.formGroup label {
  display: block;
  margin-bottom: 8px;
  font-size: 1rem;
  color: var(--text-accent);
}

.inputField {
  width: calc(100% - 20px);
  padding: 12px 10px;
  border: 1px solid var(--dark-purple);
  border-radius: 8px;
  background-color: rgba(30, 10, 60, 0.5); /* Более темный полупрозрачный фон для инпутов */
  color: var(--text-light);
  font-size: 1rem;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

.inputField::placeholder {
  color: var(--text-accent);
  opacity: 0.7;
}

.inputField:focus {
  outline: none;
  border-color: var(--medium-purple);
  box-shadow: 0 0 15px rgba(67, 97, 238, 0.5);
}

.formActions {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  margin-top: 30px;
}

.cancelButton {
  background: #555;
  color: var(--text-light);
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.95rem;
  font-weight: bold;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.4);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.cancelButton:hover {
  background: #777;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.6);
  transform: translateY(-2px);
}

.cancelButton:active {
  transform: translateY(0);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.errorMessage {
  color: var(--error-color);
  margin-top: 10px;
  font-size: 0.9rem;
  font-weight: bold;
}

.loadingMessage {
  color: var(--medium-purple);
  font-size: 1.5rem;
  margin: 50px 0;
  text-shadow: 0 0 10px rgba(67, 97, 238, 0.5);
}

/* Адаптивность для меньших экранов */
@media (max-width: 768px) {
  .profileContainer {
    padding: 25px;
    margin-bottom: 20px;
  }

  .title {
    font-size: 2rem;
  }

  .avatar {
    width: 50px;
    height: 50px;
  }

  .usernameDisplay {
    font-size: 1.4rem;
  }

  .avatarUpload {
    flex-direction: column;
  }

  .fileInputLabel,
  .uploadButton {
    width: 100%;
    text-align: center;
  }

  .formActions {
    flex-direction: column;
    gap: 10px;
  }

  .saveButton, .cancelButton {
    width: 100%;
  }
}

.logoutButton {
  background: linear-gradient(45deg, #FF416C, #FF4B2B);
  color: var(--text-light);
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: bold;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(255, 75, 43, 0.4);
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-left: 15px;
}

.logoutButton:hover {
  background: linear-gradient(45deg, #FF4B2B, #FF416C);
  box-shadow: 0 6px 20px rgba(255, 75, 43, 0.6);
  transform: translateY(-2px);
}

.logoutButton:active {
  transform: translateY(0);
  box-shadow: 0 2px 10px rgba(255, 75, 43, 0.3);
}

/* Обновим стили для header, чтобы кнопки правильно располагались */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 800px;
  margin-bottom: 20px;
}

/* Адаптивность для кнопок в шапке */
@media (max-width: 768px) {
  .header {
    flex-direction: column;
    gap: 15px;
  }
  
  .goHomeButton,
  .logoutButton {
    width: 100%;
    margin-left: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/style/profile.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,4DAA4D;EAC5D,uCAAuC;EACvC,wBAAwB;EACxB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB,EAAE,wCAAwC;AAC9D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,4EAA4E;EAC5E,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,yCAAyC;EACzC,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,4EAA4E;EAC5E,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA;EACE,uCAAuC,EAAE,8BAA8B;EACvE,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B,EAAE,kCAAkC;EAC9D,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,4BAA4B;EAC5B,sCAAsC;EACtC,2CAA2C;EAC3C,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe,EAAE,4BAA4B;EAC7C,uBAAuB;AACzB;;AAEA;EACE,aAAa,EAAE,qCAAqC;AACtD;;AAEA;;;;;EAKE,4EAA4E;EAC5E,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,yCAAyC;EACzC,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;;EAIE,4EAA4E;EAC5E,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;;;;EAIE,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,oCAAoC;EACpC,kBAAkB;EAClB,uCAAuC,EAAE,gDAAgD;EACzF,wBAAwB;EACxB,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,yCAAyC;EACzC,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,cAAc;EACd,4CAA4C;AAC9C;;AAEA,qCAAqC;AACrC;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,oDAAoD;EACpD,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,6CAA6C;EAC7C,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,oDAAoD;EACpD,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,6CAA6C;AAC/C;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;IAEE,WAAW;IACX,cAAc;EAChB;AACF","sourcesContent":["/* Переменные для цветов */\n:root {\n  --dark-purple: #3A0CA3;\n  --medium-purple: #4361EE;\n  --bright-purple: #B5179E;\n  --darkest-purple: #21094E;\n  --text-light: #E0E0E0;\n  --text-accent: #BBBBBB;\n  --border-color: #555;\n  --error-color: #FF6B6B;\n  --success-color: #6BFF8C;\n}\n\nbody {\n  margin: 0;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  background-color: var(--darkest-purple);\n  color: var(--text-light);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  overflow-x: hidden; /* Предотвращаем горизонтальный скролл */\n}\n\n.profilePage {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  min-height: 100vh;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n.header {\n  width: 100%;\n  max-width: 800px;\n  text-align: left;\n  margin-bottom: 20px;\n}\n\n.goHomeButton {\n  background: linear-gradient(45deg, var(--medium-purple), var(--dark-purple));\n  color: var(--text-light);\n  border: none;\n  padding: 10px 20px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 1rem;\n  font-weight: bold;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.4);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.goHomeButton:hover {\n  background: linear-gradient(45deg, var(--dark-purple), var(--medium-purple));\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.6);\n  transform: translateY(-2px);\n}\n\n.goHomeButton:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);\n}\n\n.profileContainer {\n  background-color: rgba(30, 10, 60, 0.7); /* Полупрозрачный темный фон */\n  border: 1px solid var(--dark-purple);\n  border-radius: 15px;\n  padding: 40px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.6);\n  text-align: center;\n  width: 100%;\n  max-width: 600px;\n  margin-bottom: 40px;\n  backdrop-filter: blur(5px); /* Футуристичный эффект размытия */\n  -webkit-backdrop-filter: blur(5px);\n}\n\n.title {\n  color: var(--bright-purple);\n  margin-bottom: 30px;\n  font-size: 2.5rem;\n  text-shadow: 0 0 10px rgba(181, 23, 158, 0.5);\n}\n\n.avatarSection {\n  margin-bottom: 30px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  border-radius: 50%;\n}\n\n.avatar {\n  width: 80px !important;\n  height: 80px !important;\n  border-radius: 50%;\n  object-fit: cover !important;\n  border: 4px solid var(--medium-purple);\n  box-shadow: 0 0 20px rgba(67, 97, 238, 0.7);\n  transition: transform 0.3s ease;\n  margin-bottom: 20px;\n}\n\n.avatar:hover {\n  transform: scale(1.05);\n}\n\n.avatarUpload {\n  display: flex;\n  gap: 15px;\n  align-items: center;\n  flex-wrap: wrap; /* Для мобильных устройств */\n  justify-content: center;\n}\n\n.fileInput {\n  display: none; /* Скрываем стандартный инпут файла */\n}\n\n.fileInputLabel,\n.uploadButton,\n.editButton,\n.saveButton,\n.cancelButton {\n  background: linear-gradient(45deg, var(--bright-purple), var(--dark-purple));\n  color: var(--text-light);\n  border: none;\n  padding: 10px 20px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 0.95rem;\n  font-weight: bold;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.4);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.fileInputLabel:hover,\n.uploadButton:hover,\n.editButton:hover,\n.saveButton:hover {\n  background: linear-gradient(45deg, var(--dark-purple), var(--bright-purple));\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.6);\n  transform: translateY(-2px);\n}\n\n.fileInputLabel:active,\n.uploadButton:active,\n.editButton:active,\n.saveButton:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);\n}\n\n.uploadButton:disabled,\n.saveButton:disabled {\n  background: #555;\n  cursor: not-allowed;\n  box-shadow: none;\n  transform: none;\n  opacity: 0.7;\n}\n\n.userInfo {\n  margin-bottom: 30px;\n}\n\n.usernameDisplay {\n  font-size: 1.6rem;\n  color: var(--text-light);\n  margin: 0;\n}\n\n.usernameDisplay span {\n  color: var(--bright-purple);\n  font-weight: bold;\n  text-shadow: 0 0 8px rgba(181, 23, 158, 0.4);\n}\n\n.editButton {\n  margin-top: 20px;\n  min-width: 200px;\n}\n\n.editForm {\n  margin-top: 30px;\n  text-align: left;\n  width: 100%;\n}\n\n.editForm h2 {\n  color: var(--medium-purple);\n  font-size: 1.8rem;\n  margin-bottom: 25px;\n  text-align: center;\n  text-shadow: 0 0 8px rgba(67, 97, 238, 0.4);\n}\n\n.formGroup {\n  margin-bottom: 20px;\n}\n\n.formGroup label {\n  display: block;\n  margin-bottom: 8px;\n  font-size: 1rem;\n  color: var(--text-accent);\n}\n\n.inputField {\n  width: calc(100% - 20px);\n  padding: 12px 10px;\n  border: 1px solid var(--dark-purple);\n  border-radius: 8px;\n  background-color: rgba(30, 10, 60, 0.5); /* Более темный полупрозрачный фон для инпутов */\n  color: var(--text-light);\n  font-size: 1rem;\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\n}\n\n.inputField::placeholder {\n  color: var(--text-accent);\n  opacity: 0.7;\n}\n\n.inputField:focus {\n  outline: none;\n  border-color: var(--medium-purple);\n  box-shadow: 0 0 15px rgba(67, 97, 238, 0.5);\n}\n\n.formActions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 15px;\n  margin-top: 30px;\n}\n\n.cancelButton {\n  background: #555;\n  color: var(--text-light);\n  border: none;\n  padding: 10px 20px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 0.95rem;\n  font-weight: bold;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.4);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.cancelButton:hover {\n  background: #777;\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.6);\n  transform: translateY(-2px);\n}\n\n.cancelButton:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);\n}\n\n.errorMessage {\n  color: var(--error-color);\n  margin-top: 10px;\n  font-size: 0.9rem;\n  font-weight: bold;\n}\n\n.loadingMessage {\n  color: var(--medium-purple);\n  font-size: 1.5rem;\n  margin: 50px 0;\n  text-shadow: 0 0 10px rgba(67, 97, 238, 0.5);\n}\n\n/* Адаптивность для меньших экранов */\n@media (max-width: 768px) {\n  .profileContainer {\n    padding: 25px;\n    margin-bottom: 20px;\n  }\n\n  .title {\n    font-size: 2rem;\n  }\n\n  .avatar {\n    width: 50px;\n    height: 50px;\n  }\n\n  .usernameDisplay {\n    font-size: 1.4rem;\n  }\n\n  .avatarUpload {\n    flex-direction: column;\n  }\n\n  .fileInputLabel,\n  .uploadButton {\n    width: 100%;\n    text-align: center;\n  }\n\n  .formActions {\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .saveButton, .cancelButton {\n    width: 100%;\n  }\n}\n\n.logoutButton {\n  background: linear-gradient(45deg, #FF416C, #FF4B2B);\n  color: var(--text-light);\n  border: none;\n  padding: 10px 20px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 1rem;\n  font-weight: bold;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(255, 75, 43, 0.4);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  margin-left: 15px;\n}\n\n.logoutButton:hover {\n  background: linear-gradient(45deg, #FF4B2B, #FF416C);\n  box-shadow: 0 6px 20px rgba(255, 75, 43, 0.6);\n  transform: translateY(-2px);\n}\n\n.logoutButton:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 10px rgba(255, 75, 43, 0.3);\n}\n\n/* Обновим стили для header, чтобы кнопки правильно располагались */\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  max-width: 800px;\n  margin-bottom: 20px;\n}\n\n/* Адаптивность для кнопок в шапке */\n@media (max-width: 768px) {\n  .header {\n    flex-direction: column;\n    gap: 15px;\n  }\n  \n  .goHomeButton,\n  .logoutButton {\n    width: 100%;\n    margin-left: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
